import React from 'react';
import cls from './ConsumerIntegrationsListHeader.module.scss';

const ConsumerIntegrationsListHeader = () => {
  return (
    <ul className={cls.Header} data-testid="integrations-header">
      <li className="regular-text">Service</li>
      <li className="regular-text">Created</li>
      <li className="regular-text">Term</li>
      <li className="regular-text">Account</li>
    </ul>
  );
};

export default ConsumerIntegrationsListHeader;
